module.exports = __webpack_public_path__ + "img/dol13.562d2d98.jpeg";